import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AssetLocationMappingController } from "./asset-location-mapping.controller";
import { AssetLocationMapping } from "./entity/asset-location-mapping.entity";
import { AssetLocationMappingService } from "./asset-location-mapping.service";
import { AssetLocationMappingAdapter } from "./entity/asset-location-mapping.adapter";
import { AssetLocationTransaction } from "./entity/asset-location-transaction.entity";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { AssetMaintainanceModule } from "../asset-maintainance/asset-maintainance.module";
import { Assets } from "../open-assets/open-assets-entity";
import { AssetTransaction } from "../open-assets/asset-transaction-entity";
import { AssetTransactionAdapter } from "../open-assets/dto/asset-transaction-adapter";
@Module({
    imports : [
        TypeOrmModule.forFeature([AssetLocationMapping,AssetLocationTransaction,Assets,AssetTransaction]),
        AssetMaintainanceModule
    ],
    controllers : [AssetLocationMappingController],
    providers : [AssetLocationMappingService,AssetLocationMappingAdapter,ApplicationExceptionHandler,AssetTransactionAdapter],
    exports: [TypeOrmModule],
})

export class AssetLocationMappingModule {}